export default __webpack_public_path__ + "static/media/i.42883966.wav";